module.exports = __webpack_public_path__ + "static/media/blog_canimolt_16nov.bc4e8c01.png";